import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {BenutzerDTO} from "../../../models/benutzer/BenutzerDTO";
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {CustomToastService} from "../../utils/custom-toast.service";
import {BenutzerService} from "../../services/benutzer/benutzer.service";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";

/*
  Route is called via confirmation email
  ("Um die Änderung erfolgreich abschließen zu können ..")

  Confirmation email is generated via endpoint: PATCH benutzer/id -> BenutzerService.updateBenutzer

  Confirmation is tied to new email address, hence ..
  formControl email => readonly = true
  formControl kennwort => readonly = false, validate: required

 */

@Component({
    selector: 'app-email-aendern',
    templateUrl: './email-aendern.component.html',
    styleUrls: ['./email-aendern.component.scss'],
    standalone: false
})
export class EmailAendernComponent implements OnInit {

  public mailAenderungForm: UntypedFormGroup;
  public dto: BenutzerDTO;

  pwHide = true;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  token: string;
  email: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              public translate: TranslateService,
              private customToastService: CustomToastService,
              private benutzerService: BenutzerService,
              private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          this.mailAenderungForm = this.fb.group({
            email:[params.email],
            kennwort:['',[Validators.required]]
          });
          this.token = params.token;
      });
  }

  getFormItem(s: string) {
    return this.mailAenderungForm?.get(s);
  }

  save(){
    if(this.mailAenderungForm.invalid){
      this.customToastService.showError('Die Angaben sind falsch oder unvollständig.');
      return;
    }
    const emailInput =  this.getFormItem('email')?.value.length !== 0 ? this.getFormItem('email').value : null;
    const kennwort = this.getFormItem('kennwort')?.value.length !== 0 ? this.getFormItem('kennwort').value : null;
    this.benutzerService.activateNewMail({
      email : emailInput,
      kennwort: kennwort,
      token : this.token
    }).pipe(
      catchError(() => {
        this.customToastService.showError('Die Aenderung konnte nicht durchgeführt werden.');
        return EMPTY;
      })
    )
      .subscribe((data: BenutzerDTO) => {
        this.dto = {...data};
        this.router.navigate(['/authentication/login']);
        this.customToastService.showSuccess("Die neue Email-Adresse wurde erfolgreich bestätigt.");
      });
  }

}
